import FiltersTab from "./FiltersTab";

export default FiltersTab;